import axios from "../utils/axios-interceptor";

export const changePasswordApi = async(payload) => {
  try {
    const res = await axios.post("/change_password", payload);
    const data = await res.data
    return data
  } catch (error) {
    throw new Error(`Error registering user: ${error.message}`);
  }
}